<div [ngSwitch]="type" [mdbTooltip]="tooltip!">
  <div *ngSwitchCase="'trashButton'">
    <a (click)="handleClick($event)">
      <jhi-bary-icon icon="trash-alt" [faDirective]="FAS" [size]="size"></jhi-bary-icon>
    </a>
  </div>
  <div *ngSwitchCase="'editButton'">
    <a (click)="handleClick($event)" class="edit-btn">
      <jhi-bary-icon icon="pen" [faDirective]="FAS" [size]="size"></jhi-bary-icon>
    </a>
  </div>
  <div *ngSwitchCase="'addMerchandise'">
    <div class="row add-btn align-items-center d-flex flex-column p-3">
      <span class="font-weight-bold" jhiTranslate="BARY_MODAL_ADD_TRANSPORT_ITEM.TITLE">Ajouter une marchandise</span>
      <jhi-bary-icon-button icon="plus" color="secondary" (clickEvent)="handleClick($event)" data-id-cypress="add-marchandise"></jhi-bary-icon-button>
    </div>
  </div>
  <div *ngSwitchDefault>NO TEMPLATE</div>
</div>
